// 首页
export default {
    home: {
        msg: '文案可以嵌套多层',
    },
};
